module.exports = __webpack_public_path__ + "img/ring_r_x_o_null@2x.4c6111ef.png";